import axios from "axios" ;


import { store , defineMessage , defineMessagetexte , defineTypeMail , defineObjet , 
   defineIdMailTransfer , modifyDisplaymodal ,defineAttachLinkMailTransfer} from "../state/redux";

export async function opentransfertwindow(email){

  const heures = (new Date(email.created_at)).getHours().toString().padStart('2',0);
  const minutes = (new Date(email.created_at)).getMinutes().toString().padStart('2',0);
  const datelong = (new Date(email.created_at)).toLocaleDateString("fr-FR", { weekday: 'long',  month: 'long', day: 'numeric' });


    //DEV AXIOS
   const emailhtml = await  axios.post(`/email/gethtml`,{'url':email?.HtmlBody});
   const message=`
<br/><br/><br/> 

---------- Message transféré ---------<br/>
De : ${email.emailFrom}<br/>
Date:  ${datelong} à ${heures}h${minutes}<br/>
Subject: ${email.emailFrom}<br/>
To: ${email.emailTo}<br/><br/><br/>


${emailhtml.data?.replace('<title>Document</title>','')}`;

const messagetexte=`
---------- Message transféré ---------
De : ${email.emailFrom}
Date:  ${datelong} à ${heures}h${minutes}
Subject: ${email.emailFrom}
To: ${email.emailTo}


${email.TextBody}` ;

return {message, messagetexte} ;

  


}


 export const clicktransferemail = async(emailchoice)=>{ 
    store.dispatch(defineTypeMail('transfer'));
    const {message, messagetexte } = await opentransfertwindow(emailchoice) ;
    store.dispatch(defineMessage(message)) ;
    store.dispatch(defineMessagetexte(messagetexte));
    store.dispatch(defineObjet('Fwd: '+emailchoice?.Subject)); 
    store.dispatch(defineIdMailTransfer(emailchoice.id)) ;
    emailchoice?.listattachements?.length >0 &&   store.dispatch(defineAttachLinkMailTransfer(emailchoice?.listattachements))
    store.dispatch(modifyDisplaymodal('mod_mailingmodal'))  ;
  
 }